import React, { useState, useEffect } from 'react';
import HeroSection from '../components/sections/HeroSection';
import ServicesGridSection from '../components/sections/ServicesGridSection';
import ServicesCTASection from '../components/sections/ServicesCTASection';


import { pagesData } from '../data/pagesData';

const sectionComponents: Record<string, React.ComponentType<any>> = {
  HeroSection,
  ServicesGridSection,
  ServicesCTASection,
};

type PageProps = { language: 'ar' | 'en' };

const Services: React.FC<PageProps> = ({ language }) => {
  const [sections, setSections] = useState<any[]>([]);

  useEffect(() => {
    const savedData = localStorage.getItem('pageData_services');
    if (savedData) {
      try {
        const parsedData = JSON.parse(savedData);
        setSections(parsedData);
        console.log('Loaded updated data from localStorage');
      } catch (error) {
        console.error('Error parsing localStorage data:', error);
        setSections(pagesData.services?.sections || []);
      }
    } else {
      setSections(pagesData.services?.sections || []);
    }
  }, []);

  return (
    <div className={`min-h-screen bg-gray-50 ${language === 'ar' ? 'font-cairo' : 'font-montserrat'}`} dir={language === 'ar' ? 'rtl' : 'ltr'}>
      {sections.map((section, idx) => {
        const SectionComponent = sectionComponents[section.type];
        if (!SectionComponent) return null;
        return (
          <SectionComponent key={idx} language={language} {...section.props} />
        );
      })}
    </div>
  );
};

export default Services; 